<template>
  <modal v-ref:modal :is-shown.sync="isShown" size="lg">
  <div slot="content">
    <div class="modal-header">
      <span>予定調整</span>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div v-if="errorResponse" class="alert alert-danger" role="alert">
        <ul>
          <li v-for="e in nonFieldErrors">{{ e }}</li>
          <li v-for="errors in fieldErrors" v-if="errors.length">
            {{ formLabels[$key] }}
            <ul>
              <li v-for="e in errors">{{ e }}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-sm-2">
          スタッフ名:
        </div>
        <div class="col-sm-6">
          {{ staffName }}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2">
          勤務時間:
        </div>
        <div class="col-sm-6">
          {{ startAtStr }} ~ {{ endAtStr }}
        </div>
      </div>
      <div style="margin-top: 100px;" class="row">
        <div class="col-sm-2">
          休憩時間1:
        </div>
        <div class="col-sm-8">
          <div class="form-group form-inline form-group-sm">
            <select class="form-control" v-model="breakStartHour1">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="breakStartMinute1">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分&nbsp;〜&nbsp;
            <select class="form-control" v-model="breakEndHour1">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="breakEndMinute1">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2">
          休憩時間2:
        </div>
        <div class="col-sm-8">
          <div class="form-group form-inline form-group-sm">
            <select class="form-control" v-model="breakStartHour2">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="breakStartMinute2">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分&nbsp;〜&nbsp;
            <select class="form-control" v-model="breakEndHour2">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="breakEndMinute2">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分
          </div>
        </div>
      </div>
      <div style="margin-top: 100px;" class="row">
        <div class="col-sm-2">
          予定1:
        </div>
        <div class="col-sm-4">
          <div class="form-group form-inline form-group-sm">
            <select class="form-control" v-model="blockStartHour1">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="blockStartMinute1">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分&nbsp;〜&nbsp;
            <select class="form-control" v-model="blockEndHour1">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="blockEndMinute1">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label class="control-label">理由:</label>
            <input v-model="blockReason1" type="text"></input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2">
          予定2:
        </div>
        <div class="col-sm-4">
          <div class="form-group form-inline form-group-sm">
            <select class="form-control" v-model="blockStartHour2">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="blockStartMinute2">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分&nbsp;〜&nbsp;
            <select class="form-control" v-model="blockEndHour2">
              <option v-for="obj in hours" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            時
            <select class="form-control" v-model="blockEndMinute2">
              <option v-for="obj in minutes" value="{{ obj.value }}">{{ obj.label }}</option>
            </select>
            分
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label class="control-label">理由:</label>
            <input v-model="blockReason2" type="text"></input>
          </div>
        </div>
      </div>
    </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="waitFor(submit())">変更</button>
      </div>
  </div>
  </modal>
</template>

<script lang="babel">
import moment from 'moment'

export default {
  name: 'break-shift-modal-form',
  props: {
    shop: {
      type: Object,
      required: true,
    },
  },
  data () {
    let data = this.defaultData()
    return data
  },
  computed: {
    nonFieldErrors() {
      if (this.errorResponse && this.errorResponse.body.nonFieldErrors) {
        return this.errorResponse.body.nonFieldErrors
      } else {
        return []
      }
    },
    fieldErrors () {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}
      Object.assign(errors, {
      })
      return errors
    },
    staffName () {
      if (!this.shift._embedded) {
        return ''
      }
      return this.shift._embedded.staff.name
    },
    startAtStr () {
      if (!this.shift.startAt) {
        return ''
      }
      return moment(this.shift.startAt).format("HH時mm分")
    },
    endAtStr () {
      if (!this.shift.endAt) {
        return ''
      }
      return moment(this.shift.endAt).format("HH時mm分")
    },
    hours () {
      let ret = [{
        value: '',
        label: '-',
      }]
      if (!this.shift.startAt) {
        return ret
      }
      var start = parseInt(moment(this.shift.startAt).format("HH"))
      var end = parseInt(moment(this.shift.endAt).format("HH"))
      for (var i = start; i <= end; i++) {
        ret.push({
          value: i,
          label: i,
        })
      }
      return ret
    },
    minutes () {
      let ret = []
      for (var i = 0; i < 60; i += 10) {
        ret.push({
          value: i,
          label: i,
        })
      }
      return ret
    },
  },
  methods: {
    parseHour (timeStr) {
      if (!timeStr) {
        return null
      }
      return parseInt(moment(timeStr).format("HH"))
    },
    parseMinute (timeStr) {
      if (!timeStr) {
        console.log('null')
        return null
      }
      return parseInt(moment(timeStr).format("mm"))
    },
    create (shift) {
      this.shift = shift
      this.isShown = true
      if (shift.breakStartAt_1) {
        this.breakStartHour1 = this.parseHour(shift.breakStartAt_1)
        this.breakStartMinute1 = this.parseMinute(shift.breakStartAt_1)
      } else {
        this.breakStartHour1 = null
        this.breakStartMinute1 = null
      }

      if (shift.breakEndAt_1) {
        this.breakEndHour1 = this.parseHour(shift.breakEndAt_1)
        this.breakEndMinute1 = this.parseMinute(shift.breakEndAt_1)
      } else {
        this.breakEndHour1 = null
        this.breakEndMinute1 = null
      }

      if (shift.breakStartAt_2) {
        this.breakStartHour2 = this.parseHour(shift.breakStartAt_2)
        this.breakStartMinute2 = this.parseMinute(shift.breakStartAt_2)
      } else {
        this.breakStartHour2 = null
        this.breakStartMinute2 = null
      }

      if (shift.breakEndAt_2) {
        this.breakEndHour2 = this.parseHour(shift.breakEndAt_2)
        this.breakEndMinute2 = this.parseMinute(shift.breakEndAt_2)
      } else {
        this.breakEndHour2 = null
        this.breakEndMinute2 = null
      }
      if (shift.blockStartAt_1) {
        this.blockStartHour1 = this.parseHour(shift.blockStartAt_1)
        this.blockStartMinute1 = this.parseMinute(shift.blockStartAt_1)
      } else {
        this.blockStartHour1 = null
        this.blockStartMinute1 = null
      }

      if (shift.blockEndAt_1) {
        this.blockEndHour1 = this.parseHour(shift.blockEndAt_1)
        this.blockEndMinute1 = this.parseMinute(shift.blockEndAt_1)
      } else {
        this.blockEndHour1 = null
        this.blockEndMinute1 = null
      }

      if (shift.blockStartAt_2) {
        this.blockStartHour2 = this.parseHour(shift.blockStartAt_2)
        this.blockStartMinute2 = this.parseMinute(shift.blockStartAt_2)
      } else {
        this.blockStartHour2 = null
        this.blockStartMinute2 = null
      }

      if (shift.blockEndAt_2) {
        this.blockEndHour2 = this.parseHour(shift.blockEndAt_2)
        this.blockEndMinute2 = this.parseMinute(shift.blockEndAt_2)
      } else {
        this.blockEndHour2 = null
        this.blockEndMinute2 = null
      }
      this.blockReason1 = shift.blockReason_1
      this.blockReason2 = shift.blockReason_2
    },
    defaultData () {
      return {
        errorResponse: null,
        shift: {},
        breakStartHour1: null,
        breakStartMinute1: null,
        breakEndHour1: null,
        breakEndMinute1: null,
        breakStartHour2: null,
        breakStartMinute2: null,
        breakEndHour2: null,
        breakEndMinute2: null,
        blockStartHour1: null,
        blockStartMinute1: null,
        blockEndHour1: null,
        blockEndMinute1: null,
        blockStartHour2: null,
        blockStartMinute2: null,
        blockEndHour2: null,
        blockEndMinute2: null,
        blockReason1: null,
        blockReason2: null,
        isShown: false,
        formLabels: {
        },
      }
    },
    reset () {
      let data = this.defaultData()
      Object.keys(data).forEach(k => this[k] = data[k])
    },
    close () {
      this.isShown = false;
    },
    submit () {
      let data = {
        breakStartHour_1: this.breakStartHour1 !== '' ? this.breakStartHour1 : null,
        breakStartMinute_1: this.breakStartMinute1,
        breakEndHour_1: this.breakEndHour1 !== '' ? this.breakEndHour1 : null,
        breakEndMinute_1: this.breakEndMinute1,
        breakStartHour_2: this.breakStartHour2 !== '' ? this.breakStartHour2 : null,
        breakStartMinute_2: this.breakStartMinute2,
        breakEndHour_2: this.breakEndHour2 !== '' ? this.breakEndHour2 : null,
        breakEndMinute_2: this.breakEndMinute2,
        blockStartHour_1: this.blockStartHour1 !== '' ? this.blockStartHour1 : null,
        blockStartMinute_1: this.blockStartMinute1,
        blockEndHour_1: this.blockEndHour1 !== '' ? this.blockEndHour1 : null,
        blockEndMinute_1: this.blockEndMinute1,
        blockStartHour_2: this.blockStartHour2 !== '' ? this.blockStartHour2 : null,
        blockStartMinute_2: this.blockStartMinute2,
        blockEndHour_2: this.blockEndHour2 !== '' ? this.blockEndHour2 : null,
        blockEndMinute_2: this.blockEndMinute2,
        blockReason_1: this.blockReason1 ? this.blockReason1 : '',
        blockReason_2: this.blockReason2 ? this.blockReason2 : '',
      }

      return this.apiPut(
        `/api/1.0/shifts/${this.shift.pk}/`,
        data,
        {shopAs: this.shop.pk}
      ).then(response => {
        // alert('休憩時間を変更しました')
        this.reset()
        this.close()
        location.reload()
      }).catch(reason => {
        console.log(reason)
        if (reason.error.status === 400) {
          this.errorResponse = reason.response
        }
        return Promise.reject(reason)
      })
    },
  },
  mixins: [
    require('mixin/api-client.vue'),
    require('mixin/wait.vue'),
  ],
  components: {
    modal: require('ui/modal.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// break-shift.vue?416a5a21